/**
 * 밸런스 JSON 핫리로드 알림.
 * 데이터 모듈은 Phaser 를 import 하지 않는다. 씬 재시작은 main 이 담당한다.
 */

export const DATA_RELOAD_EVENT = 'maple-data-reload';

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function requireRecord(value: unknown, label: string): Record<string, unknown> {
  if (!isRecord(value)) throw new Error(`${label} 객체가 아닙니다`);
  return value;
}

export function replaceRecord<T extends Record<string, unknown>>(target: T, next: T): void {
  for (const key of Object.keys(target)) {
    if (!(key in next)) delete target[key];
  }
  Object.assign(target, next);
}

export function replaceArray<T>(target: T[], next: readonly T[]): void {
  target.length = 0;
  target.push(...next);
}

export function emitDataReload(): void {
  window.dispatchEvent(new CustomEvent(DATA_RELOAD_EVENT));
}

let reloadTimer = 0;

/** JSON 여러 파일이 한꺼번에 바뀌어도 플레이 씬은 한 번만 다시 연다 */
export function emitDataReloadSoon(): void {
  window.clearTimeout(reloadTimer);
  reloadTimer = window.setTimeout(() => emitDataReload(), 40);
}
